import * as React from 'react';

export interface IProps {
    children: any;
}

export function ButtonSet(props: IProps) {
    return <span className='p-buttonset'>{props.children}</span>
}